module.exports = __webpack_public_path__ + "static/media/unlink.059666ca.svg";